import * as React from "react";
import { I18n } from "react-redux-i18n";
import { Actions as ActionsBase } from "@common/components/actions";
import { SpreadsheetType } from "@modules/spreadsheets/dto/spreadsheet/type";

import "./actions.styles.scss";

export type ActionsProps = {
  disabledState: {
    run: boolean;
    saveFmt: boolean;
  };
  onLoadFormat: () => void;
  onSaveFmt: () => void;
  onRun: () => Promise<void>;
  spreadsheetType: SpreadsheetType;
  isRunLoading?: boolean;
  onUndo?: () => void;
  onRedo?: () => void;
  canUndo?: boolean;
  canRedo?: boolean;
};

export const Actions: React.FC<ActionsProps> = (props) => {
  const { 
    onLoadFormat, 
    onRun, 
    onSaveFmt, 
    disabledState, 
    spreadsheetType, 
    isRunLoading = false,
    onUndo,
    onRedo,
    canUndo = false,
    canRedo = false,
  } = props;

  const actions = [
    // Undo/Redo actions (only show if functions are provided)
    ...(onUndo ? [{
      iconSrc: "png/undo.png",
      label: "Undo",
      onClick: onUndo,
      disabled: !canUndo,
    }] : []),
    ...(onRedo ? [{
      iconSrc: "png/redo.png", 
      label: "Redo",
      onClick: onRedo,
      disabled: !canRedo,
    }] : []),
    // Existing actions
    {
      iconSrc: "png/run.png",
      label: "Run",
      onClick: onRun,
      disabled: disabledState.run || isRunLoading,
      loading: isRunLoading,
    },
    {
      iconSrc: "gif/load_fmt.gif",
      label: "Load Fmt",
      onClick: onLoadFormat,
    },
    {
      iconSrc: "gif/save_fmt.gif",
      label: "Save Fmt",
      disabled: disabledState.saveFmt,
      onClick: onSaveFmt,
    },
  ].map(({ label, ...restData }, index) => ({
    ...restData,
    id: spreadsheetType === SpreadsheetType.individual
      ? `ISSC-sswnd-item${index}-btn`
      : `PSSC-sswnd-item${index}-btn`,
    label: I18n.t(label),
  }));

  return <ActionsBase items={actions} />;
};
